module.exports = __webpack_public_path__ + "img/google-play.1b77bc66.svg";